import React from 'react';
import { Container } from 'semantic-ui-react';
import { toSnakeCase } from '../helpers/common';

const CallToAction = ({ module }) => {
  return (
    <section
      id={
        module.anchorTagLinkText && `${toSnakeCase(module.anchorTagLinkText)}`
      }
    >
      <Container>
        <div className="grid-wrapper">
          <div
            className="tablepress__wrapper tablepress__container"
            dangerouslySetInnerHTML={{
              __html: module?.newTable?.tableData
                ? module.newTable.tableData
                : null,
            }}
          />
        </div>
      </Container>
    </section>
  );
};

export default CallToAction;
